import { CustomTable, CustomTableHeadersProps, CustomTableRowsProps } from '@dev/ee-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getCampaignsStore } from '@/store/campaigns/actions';
import { CampaignsCustomTableWrapper, customClassForColumnCells } from './StyledComponents';

const columnsWidth = {
    preview: '11%',
    campaignName: '22%',
    delivered: '10%',
    opened: '9%',
    clicked: '9%',
    status: '110px',
    viewReport: '180px',
};

type DesktopListTableT = {
    rows: CustomTableRowsProps[];
    headers: CustomTableHeadersProps[];
    onSelectRow?(ev: React.ChangeEvent<unknown>, selectedRows?: string[], selectAll?: boolean): void;
};

export const DesktopListTable = ({ headers, rows, onSelectRow }: DesktopListTableT) => {
    const { t } = useTranslation();
    const campaigns = useSelector(getCampaignsStore);

    return (
        <CampaignsCustomTableWrapper>
            <CustomTable
                headers={headers}
                rows={rows}
                emptyRowsNo={campaigns.pagination.perPage}
                stickyHeader
                rowHeight={138}
                isEmpty={!campaigns.collection.length && !campaigns.loading}
                rowPadding={48}
                columnsWidth={columnsWidth}
                onSelectRow={onSelectRow}
                selectedRows={campaigns.checkedCampaigns}
                totalCount={campaigns?.statusCount?.total}
                isHeaderCheckboxEnabled
                disableFirstRowBorderTop
                emptyStateProps={{ text: t('emptystate') }}
                disableRowClick
                customCellClassName={customClassForColumnCells}
            />
        </CampaignsCustomTableWrapper>
    );
};
